// Auto-generated - do not edit
export const RELEASE = '5deb44483547c5ee3049bdadc1858d9497671605';
